<template>
  <div
    v-if="expand || $props.num < 10"
    ref="collection_item"
    :class="expand ? 'collection-item-expand' : 'collection-item'"
    title="Select Item"
  >
    <img
      :src="$props.resource.imageUri"
      class="collection-image"
    />
  </div>
</template>

<script>
export default {
  name: 'CollectionItem',
  props: [
    'expand',
    'resource',
    'num'
  ],
};
</script>

<style scoped>
.collection-item {
  width: calc((100%/5) - 5px);
  aspect-ratio : 1 / 1;
  background-color: white;
  margin: 2px;
  transition: width .2s, height .2s, margin .2s;
  border: 1px solid white;
}
.collection-item-expand {
  width: calc((100%/4) - 4px);
  aspect-ratio : 1 / 1;
  background-color: white;
  margin: 2px;
  transition: width .2s, height .2s, margin .2s;
  border: 1px solid white;
}

.collection-image {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

</style>
